import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IService } from "../../utils/types/models";

export default createEntityReducer<IService>(Endpoint.Services, Endpoint.ServicesList);
